import angular from 'angular';
import namesTemplate from './templates/names.template.html';

/*******************************************************************************
 * Component: namesEntityContent
 *
 * Component to manage the Names route content.
 *******************************************************************************/   
export const namesEntityContentComponent = {
  require: { dialogCtrl: '^^entitiesAdmin' },
  template: namesTemplate,
  controller: 'NamesEntityController',
  controllerAs: '$namesCtrl'
}

/* @ngInject */ export function NamesEntityController(
  Alert,
  AddChangeEntityDialog,
  AddChangeStudentDialog,
  BooksSvc,
  BusyScreen,
  EntitiesAdminService,
  EntityMaker,
  MakeMemberDialog,
  MergeEntityDialog,
  NamesListDialog,
  SERVER,
  uiGridConstants
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Controller Instance Reference. */ var mThis = this;
  /** Entity Maker dialog shown.     */ var mEntityMakerActive = false;
  /** Make Member Dialog shown.      */ var mMakeMemberDialogActive = false;
  /** Make Member Dialog shown.      */ var mMergeEntityDialogActive = false;
  /** Names List Dialog shown.       */ var mNamesListDialogActive = false;
  /** Booster/PTA indicator flag.    */ mThis.isBoosterPTA =
    SERVER.productID != 'ASB Works';

  /*-----------------------------------------------------*/
  /* Template to add double click functionality to each  */
  /* grid row. Begins editing the double clicked entity. */
  /*-----------------------------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.changeEntity(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

  /*-----------------------------------*/
  /* Entities grid Type column filter. */
  /*-----------------------------------*/
  var mTypeFilter = {
    term: null,
    type: uiGridConstants.filter.SELECT,
    condition: uiGridConstants.filter.EXACT
  };
  var mRoleFilter = { term: null, type: uiGridConstants.filter.SELECT };

  /*------------------------------------------------------------*/
  /* Template for the actions column with icons to edit entity, */
  /* make ASB card holder, merge entity and delete entity.      */
  /*------------------------------------------------------------*/
  var actionsCellTemplate =
    '<div class="ui-grid-cell-contents ng-binding ng-scope">' +
    '<span ng-hide="(col.colDef.appScope || grid.appScope).dialogCtrl.restrictIndividuals"><span style="cursor:pointer" class="glyphicon glyphicon-edit         csm-grid-space-target" title="Change"               ng-click="(col.colDef.appScope || grid.appScope).changeEntity(row.entity)"></span> &nbsp;</span>' +
    '<span ng-hide="(col.colDef.appScope || grid.appScope).dialogCtrl.restrictSecurity"><span style="cursor:pointer" class="glyphicon glyphicon-user         csm-grid-space-target" title="Create/Change Login"  add-change-system-login-dialog entity-id="row.entity.id" define-props="(col.colDef.appScope || grid.appScope).handleLogins" on-save="(col.colDef.appScope || grid.appScope).onSave(response)"></span> &nbsp;</span>' +
    '<span ng-hide="(col.colDef.appScope || grid.appScope).dialogCtrl.hideAsbCard">     <span style="cursor:pointer" class="glyphicon glyphicon-credit-card  csm-grid-space-target" title="Make ASB Card Holder" ng-click="(col.colDef.appScope || grid.appScope).handleMember(row.entity)"></span> &nbsp;</span>' +
    '<span ng-hide="(col.colDef.appScope || grid.appScope).dialogCtrl.restrictIndividuals"><span style="cursor:pointer" class="glyphicon glyphicon-resize-small csm-grid-space-target" title="Merge"                ng-click="(col.colDef.appScope || grid.appScope).handleMerge(row.entity)"></span> &nbsp;</span>' +
    '<span ng-hide="(col.colDef.appScope || grid.appScope).dialogCtrl.restrictIndividuals"><span style="cursor:pointer" class="glyphicon glyphicon-trash        csm-grid-space-target" title="Remove"               ng-click="(col.colDef.appScope || grid.appScope).removeEntity(row.entity)"></span> &nbsp;</span>' +
    '</div>';

  /*-----------------------*/
  /* Entities List options */
  /*-----------------------*/
  mThis.dgEntities = {
    enableColumnMenus: false,
    enableFiltering: true,
    enableRowSelection: true,
    enableFullRowSelection: true,
    enableRowHeaderSelection: false,
    multiSelect: false,
    enableSelectAll: false,
    saveFilter: true,
    saveSort: true,
    rowTemplate: dblClickTemplate,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    onRegisterApi: function (gridApi) {
      mThis.dgEntities.api = gridApi;
    },
    data: [],
    columnDefs: [
      {
        cellClass: getInactiveCellClass,
        field: 'type',
        labelFunction: getTypeString,
        width: '12%',
        minWidth: 105,
        filter: mTypeFilter
      },
      {
        cellClass: getInactiveCellClass,
        displayName: 'Student ID',
        width: '15%',
        field: 'studentID',
        minWidth: 135,
        filter: { condition: uiGridConstants.filter.STARTS_WITH }
      },
      {
        cellClass: getInactiveCellClass,
        field: 'name',
        minWidth: 250
      },
      {
        cellClass: getInactiveCellClass,
        displayName: 'Student Funds',
        labelFunction: getStudentFunds,
        width: '15%',
        field: 'funds',
        minWidth: 135,
        filter: { condition: uiGridConstants.filter.STARTS_WITH }
      },
      {
        cellClass: getInactiveCellClass,
        displayName: 'ASB Card Year',
        enableFiltering: false,
        field: 'membershipYear',
        labelFunction: getFullMembershipYear,
        width: '14%',
        minWidth: 80
      },
      {
        cellClass: getRoleCellClass,
        field: 'role',
        filter: mRoleFilter,
        width: '12%',
        minWidth: 140
      },
      {
        cellClass: getInactiveCellClass,
        field: 'active',
        width: '7%',
        minWidth: 75,
        displayName: 'Active?',
        cellFilter: 'boolToString',
        filter: {
          term: true,
          type: uiGridConstants.filter.SELECT,
          selectOptions: [
            { value: null, label: 'ALL' },
            { value: true, label: 'Y' },
            { value: false, label: 'N' }
          ]
        }
      },
      {
        cellTemplate: actionsCellTemplate,
        enableFiltering: false,
        enableSorting: false,
        field: 'actions',
        width: 130,
        displayName: 'Actions',
        pinnedRight: true,
        appScope: mThis
      }
    ]
  };

  /***************************************************************************
   * addEntity */
  /**
   * Displays the dialog to add a new entity.
   ***************************************************************************/
  mThis.addEntity = function () {
    /*----------------------------------------*/
    /* Entity maker is already active, abort. */
    /*----------------------------------------*/
    if (mEntityMakerActive) return;

    /*---------------------------*/
    /* Display the Entity Maker. */
    /*---------------------------*/
    mEntityMakerActive = true;
    EntityMaker.newEntity(null, null, null, true, true)
      .then(function (result) {
        BusyScreen.setBusy(true);
        EntitiesAdminService.reloadNames().then(function () {
          mThis.dgEntities.data = EntitiesAdminService.getNames();
          BusyScreen.setBusy(false);
          Alert.success('Sucessfully added.');
        });
      })
      .finally(function () {
        mEntityMakerActive = false;
      });
  };

  /***************************************************************************
   * changeEntity */
  /**
   * Displays the dialog to modify an existing entity depending on the entity
   * type.
   *
   * @param   entity  Entity to modify.
   ***************************************************************************/
  mThis.changeEntity = function (entity) {
    /*---------------------------------------*/
    /* Entity maker is already active, exit. */
    /*---------------------------------------*/
    if (mEntityMakerActive) return;

    /*---------------------------*/
    /* No entity provided, exit. */
    /*---------------------------*/
    if (!entity) return;

    /*--------------------------------------------------*/
    /* Get the correct dialog based on the entity type. */
    /*--------------------------------------------------*/
    var dialog;
    switch (entity.types[0]) {
      case SERVER.BooksDBConstants.ET_STUDENT:
        dialog = AddChangeStudentDialog.show(entity.id);
        break;
      case SERVER.BooksDBConstants.ET_TEACHER:
      case SERVER.BooksDBConstants.ET_PARENT:
      case SERVER.BooksDBConstants.ET_GRANDPARENT:
      case SERVER.BooksDBConstants.ET_COMMUNITY_PARTNER:
      case SERVER.BooksDBConstants.ET_FAMILY:
      case SERVER.BooksDBConstants.ET_OTHER:
        dialog = AddChangeEntityDialog.show(entity.id, entity.types[0]);
        break;
    }

    /*-----------------------------------------*/
    /* Display the dialog to manage selection. */
    /*-----------------------------------------*/
    mEntityMakerActive = true;
    dialog
      .then(function (result) {
        BusyScreen.setBusy(true);
        EntitiesAdminService.reloadNames().then(function () {
          mThis.dgEntities.data = EntitiesAdminService.getNames();
          BusyScreen.setBusy(false);
          Alert.success('Sucessfully updated.');
        });
      })
      .finally(function () {
        mEntityMakerActive = false;
      });
  };

  /***************************************************************************
   * getFullMembershipYear */
  /**
   * Returns the full fiscal membership year if present, otherwise an emtpy
   * string is returned.
   ***************************************************************************/
  function getFullMembershipYear(item) {
    return item.membershipYear == 0
      ? 'N/A'
      : item.membershipYear.toString() +
          '-' +
          (item.membershipYear + 1).toString();
  }

  /***************************************************************************
   * getStudentFunds
   *
   * Student funds are only used by student entities and only is implemented
   * in the ASB product.
   ***************************************************************************/
  function getStudentFunds(item) {
    const type = item.types[0];

    if (type !== SERVER.BooksDBConstants.ET_STUDENT) {
      return 'N/A';
    }

    return item.funds.toFixed(2);
  }

  /***************************************************************************
   * getTypeString */
  /**
   * Returns the type as its string representation
   ***************************************************************************/
  function getTypeString(item) {
    switch (item.types[0] || 0) {
      case SERVER.BooksDBConstants.ET_FAMILY:
        return 'Family';
      case SERVER.BooksDBConstants.ET_OTHER:
        return 'Other';
      case SERVER.BooksDBConstants.ET_PARENT:
        return 'Parent';
      case SERVER.BooksDBConstants.ET_GRANDPARENT:
        return 'Grandparent';
      case SERVER.BooksDBConstants.ET_COMMUNITY_PARTNER:
        return 'Community Partner';
      case SERVER.BooksDBConstants.ET_STUDENT:
        return 'Student';
      case SERVER.BooksDBConstants.ET_TEACHER:
        return 'Teacher';
      default:
        return '';
    }
  }

  /***************************************************************************
   * getInactiveCellClass */
  /**
   * Returns the CSS class name to be applied to the grid cell on inactive
   * items.
   *
   * @param  grid   ui-grid reference
   * @param  row    ui-grid row
   * @param  col    ui-grid column
   *
   * @return  String   CSS class name inactive-cell-content or empty string.
   ***************************************************************************/
  function getInactiveCellClass(grid, row, col) {
    return !row.entity.active ? 'inactive-cell-content' : '';
  }

  /***************************************************************************
   * getRoleCellClass */
  /**
   * Returns the CSS class name to be applied to the grid role cell.
   *
   * @param  grid   ui-grid reference
   * @param  row    ui-grid row
   * @param  col    ui-grid column
   *
   * @return  String   CSS class name or empty string.
   ***************************************************************************/
  function getRoleCellClass(grid, row, col) {
    var className = '';
    switch (row.entity.roleTextColor) {
      case 'default':
        className = 'entity-role-default';
        break;
      case 'inactive':
        className = 'entity-role-inactive';
        break;
      case 'valid':
        className = 'entity-role-valid';
        break;
      case 'expired':
        className = 'entity-role-expired';
        break;
    }
    return className;
  }

  /***************************************************************************
   * handleLogins */
  /**
   * Creates the config props for addChangeSystemLoginDialog.
   *
   * @return  Object that has the configuration props for addChangeSystemLoginDialog to consume.
   ***************************************************************************/
  mThis.handleLogins = function () {
    var props = {};

    /*-------------------------------------------*/
    /* For PTA/Booster, restrict available roles */
    /* in the dialog if the app flag is set.     */
    /*-------------------------------------------*/
    props.roles = mThis.dialogCtrl.restrictPTARoles
      ? ['President', 'Treasurer']
      : [];

    /*-----------------------------------------------*/
    /* Show date only when required for PTA/Booster. */
    /*-----------------------------------------------*/
    props.alwaysShowDate = !mThis.isBoosterPTA;

    return props;
  };

  /*****************************************************************************
   * onSave */
  /**
   * Reloads the list of entities after saving the login info.
   *****************************************************************************/
  mThis.onSave = function (resp) {
    /*----------------------------*/
    /* Refresh the list of names. */
    /*----------------------------*/
    BusyScreen.setBusy(true);
    EntitiesAdminService.reloadNames()
      .then(function () {
        mThis.dgEntities.data = EntitiesAdminService.getNames();
        BusyScreen.setBusy(false);

        /*------------------------*/
        /* Notify user of update. */
        /*------------------------*/
        var msg =
          'The security has been updated successfully for the user.';
        if (resp.save && resp.userName)
          msg += ' His/Her username is ' + resp.userName + '.';

        Alert.success(msg, 'Security Updated');
      });
  };

  /***************************************************************************
   * handleMember */
  /**
   * Displays the dialog to make an entity an ASB card holder.
   *
   * @param   entity  Entity to modify.
   ***************************************************************************/
  mThis.handleMember = function (entity) {
    /*------------------------------*/
    /* Dialog already active, exit. */
    /*------------------------------*/
    if (mMakeMemberDialogActive) return;

    /*----------------------------------*/
    /* Hide asb card flag is set, exit. */
    /*----------------------------------*/
    if (mThis.dialogCtrl.hideAsbCard) return;

    /*-----------------------*/
    /* Check for a selection */
    /*-----------------------*/
    if (!entity) {
      Alert.info(
        'Please make a selection from the list.',
        'No Selection'
      );
      return;
    }

    /*--------------------------------*/
    /* Display dialog to modify data. */
    /*--------------------------------*/
    mMakeMemberDialogActive = true;
    MakeMemberDialog.show(entity.id)
      .then(function () {
        BusyScreen.setBusy(true);
        EntitiesAdminService.reloadNames().then(function () {
          mThis.dgEntities.data = EntitiesAdminService.getNames();
          mThis.dgEntities.api.core.refresh();
          BusyScreen.setBusy(false);
          Alert.success('Update successful.');
        });
      })
      .finally(function () {
        mMakeMemberDialogActive = false;
      });
  };

  /***************************************************************************
   * handleMerge */
  /**
   * Displays the dialog to handle merging entities.
   *
   * @param   entity  Entity to merge to.
   ***************************************************************************/
  mThis.handleMerge = function (entity) {
    /*------------------------------*/
    /* Dialog already active, exit. */
    /*------------------------------*/
    if (mMergeEntityDialogActive) return;

    /*-----------------------*/
    /* Check for a selection */
    /*-----------------------*/
    if (!entity) {
      Alert.info(
        'Please make a selection from the list.',
        'No Selection'
      );
      return;
    }

    /*---------------------------------------*/
    /* Display the dialog to merge entities. */
    /*---------------------------------------*/
    mMergeEntityDialogActive = true;
    MergeEntityDialog.show(
      entity.id,
      entity.name,
      EntitiesAdminService.getNames()
    )
      .then(function () {
        BusyScreen.setBusy(true);
        EntitiesAdminService.reloadNames().then(function () {
          mThis.dgEntities.data = EntitiesAdminService.getNames();
          mThis.dgEntities.api.core.refresh();
          BusyScreen.setBusy(false);
          Alert.success('Merge Successful.');
        });
      })
      .finally(function () {
        mMergeEntityDialogActive = false;
      });
  };

  /***************************************************************************
   * handlePrint */
  /**
   * Displays the dialog to handle printing.
   ***************************************************************************/
  mThis.handlePrint = function () {
    /*------------------------------*/
    /* Dialog already active, exit. */
    /*------------------------------*/
    if (mNamesListDialogActive) return;

    /*---------------------------------*/
    /* Flags to be passed into dialog. */
    /*---------------------------------*/
    var hideFamily = mThis.isBoosterPTA ? false : true;
    var hideMembers = mThis.isBoosterPTA ? true : false;

    mNamesListDialogActive = true;
    NamesListDialog.show(hideFamily, hideMembers, null, null)
      .then(function () {})
      .finally(function () {
        mNamesListDialogActive = false;
      });
  };

  /*****************************************************************************
   * $onInit */
  /**
   * Initialization callback function. The required dialogCtrl will be available
   * at this point for initialization purposes.
   *****************************************************************************/
  mThis.$onInit = function () {
    /*---------------------------------------------*/
    /* A special value indicator for the 'No Role' */
    /* option. Used in the Role column filter.     */
    /*---------------------------------------------*/
    var NOROLE = 'NOROLE';

    /*-----------------------------------------------------*/
    /* To have a reference to the app scope in the grid    */
    /* row template, the grid appScopeProvider will need   */
    /* to be manually setup since we are not using $scope. */
    /*-----------------------------------------------------*/
    this.dgEntities.appScopeProvider = this;

    /*----------------*/
    /* Populate grid. */
    /*----------------*/
    BusyScreen.setBusy(true);
    EntitiesAdminService.reloadNames().then(function () {
      BusyScreen.setBusy(false);
      mThis.dgEntities.data = EntitiesAdminService.getNames();

      /*----------------------------------------------------------*/
      /* To set up the Type & Role column filters, go through all */
      /* entities and add unique type names and roles to arrays.  */
      /*----------------------------------------------------------*/
      var typeSelectOptions = [];
      var roleSelectOptions = [];
      angular.forEach(mThis.dgEntities.data, function (entity) {
        var entityType = getTypeString(entity);
        if (typeSelectOptions.indexOf(entityType) < 0)
          typeSelectOptions.push(entityType);

        if (entity.role && roleSelectOptions.indexOf(entity.role) < 0)
          roleSelectOptions.push(entity.role);
      });

      /*---------------------------------------------------*/
      /* Map the list of types to the selectOption format. */
      /*---------------------------------------------------*/
      typeSelectOptions = typeSelectOptions.map(function (tso) {
        return { value: tso, label: tso };
      });
      typeSelectOptions.unshift({ value: null, label: '-- All --' });

      /*----------------------------------------------*/
      /* Map the list of roles to the selectOption    */
      /* format, including options for displaying all */
      /* roles and entities with no assigned role.    */
      /*----------------------------------------------*/
      roleSelectOptions = roleSelectOptions.map(function (rso) {
        return { value: rso, label: rso };
      });
      roleSelectOptions.unshift({
        value: NOROLE,
        label: '-- No Role --'
      });
      roleSelectOptions.unshift({ value: null, label: '-- All --' });

      /*---------------------------------------*/
      /* Filter condition for the role column. */
      /*---------------------------------------*/
      mRoleFilter.condition = function (searchTerm, cellValue) {
        /*----------------------------------*/
        /* No Role' option selected, return */
        /* entities with no roles assigned. */
        /*----------------------------------*/
        if (searchTerm === NOROLE) return cellValue === null;
        /*-------------------------------------------------------*/
        /* Selected role is not an empty string, return matches. */
        /*-------------------------------------------------------*/ else if (
          searchTerm.trim()
        )
          return cellValue == searchTerm;
      };

      /*---------------------------------------------*/
      /* Update the filters with the select options. */
      /*---------------------------------------------*/
      mTypeFilter.selectOptions = typeSelectOptions;
      mRoleFilter.selectOptions = roleSelectOptions;

      /*---------------------------------------------*/
      /* Set visibility on the ASB Card Year column. */
      /*---------------------------------------------*/
      mThis.dgEntities.columnDefs[3].visible =
        !mThis.dialogCtrl.hideAsbCard;

      /*----------------------------------*/
      /* Set the Student ID column field. */
      /*----------------------------------*/
      mThis.dgEntities.columnDefs[1].field = mThis.dialogCtrl
        .studentIdOnly
        ? 'studentID'
        : 'studentGradeLabel';

      /*------------------------------------------------------------------*/
      /* Disable access to create/change login if security is restricted. */
      /*------------------------------------------------------------------*/
      mThis.dialogCtrl.restrictSecurity =
        SERVER.appFlags.restrictSecurity;
    });
  };

  /*****************************************************************************
   * removeEntity */
  /**
   * Removes the selected entity from the list.
   *
   * @param   entity  Entity to remove.
   *****************************************************************************/
  mThis.removeEntity = function (entity) {
    /*-----------------------*/
    /* Check for a selection */
    /*-----------------------*/
    if (!entity) {
      Alert.info('A selection is needed for the remove.', 'No Selection');
      return;
    }

    /*--------------------*/
    /* Confirm the remove */
    /*--------------------*/
    Alert.confirm(
      'Are you sure wish to remove this person?',
      'Remove Confirm'
    ).then(function () {
      BusyScreen.setBusy(true);

      /*--------------------------------------------------*/
      /* Get the type, the groups will all be groups,     */
      /* but the entity list can be one of several types. */
      /*--------------------------------------------------*/
      var entityID = entity.id;
      var type = entity.types[0];

      /*----------------------------------------*/
      /* Remove the entity and reload the list. */
      /*----------------------------------------*/
      BooksSvc.removeEntity(type, entityID).then(
        function (resp) {
          EntitiesAdminService.reloadNames().then(function () {
            mThis.dgEntities.data = EntitiesAdminService.getNames();
            BusyScreen.setBusy(false);
            Alert.success('Person sucessfully removed.');
          });
        },
        /*--------------------------------------------------*/
        /* Server responded with an error. Display to user. */
        /*--------------------------------------------------*/
        function (resp) {
          Alert.error(
            resp.parsedResponse.message() || 'Error deleting this person',
            'Failed to remove person.'
          );
          BusyScreen.setBusy(false);
        }
      );
    });
  };
}
